import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../../lib/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  className?: string;
  scrollTarget?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = '',
  scrollTarget,
  ...props
}) => {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 font-display text-lg uppercase tracking-wider transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-red-600 animate-pulse-glow',
    outline: 'border-2 border-brand-red text-brand-red hover:bg-brand-red/10'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} onClick={e => {
    if (scrollTarget) {
      const target = document.getElementById(scrollTarget);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // Fire Meta Pixel AddToCart event before redirecting
      trackEvent('AddToCart', {
        content_name: 'El Plan de Recuperación de las 24 Horas',
        content_ids: ['52704591675681'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
      window.location.href = 'https://indicadoresvip.com/cart/52704591675681:1';
    }
    props.onClick?.(e);
  }} data-id="element-191">
      <span className="relative z-10 flex items-center gap-2" data-id="element-192">{children}</span>
      {variant === 'primary' && <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-193" />}
    </motion.button>;
};